import React, {useEffect, useState} from 'react'
import {RequestedDevicesModel} from '../../../../entities/device.entity'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {DOCTOR_ALL_REQUESTED_DEVICES_HEADERS} from '../../../../constants/RoleConstants'
import DataTableList from '../../components/DataTableList'
import {useReduxAuth} from '../../../auth'
import MetaTags from '../../../../meta/MetaTags'

const DoctorRequestedDevices = () => {
  const {currentUser} = useReduxAuth()
  const [deviceRequests, setDeviceRequests] = useState<RequestedDevicesModel[]>([])

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const queryParams = currentUser?.isNurse ? 'is_nurse=1' : null
        const response = await axios.get(
          API_ENDPOINTS.GET_ALL_DEVICES_REQUESTED_BY_A_DOCTOR(currentUser?.id, queryParams)
        )
        setDeviceRequests(response.data?.data?.devices)
      } catch (error) {
        // Add Error Component
      }
    }
    fetchDevices()
  }, [])

  return (
    <>
      <MetaTags title={'Device List'} />

      <DataTableList
        showAddButton={false}
        title={'Device List'}
        columns={DOCTOR_ALL_REQUESTED_DEVICES_HEADERS}
        data={deviceRequests}
      />
    </>
  )
}

export default DoctorRequestedDevices
